import querystring from 'query-string';
import { oauth_dev } from './constants';

async function fetchDataApi(apiUrl, method, params, payload, headers) {
    const requestOptions = {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    if(headers){
      requestOptions.headers = headers;
    }
    if (payload) {
      requestOptions['body'] = payload;
    }
    if (params) {
      apiUrl = apiUrl.concat('?').concat(querystring.stringify(params));
    }
    try {
      const responsePromise = await fetch(apiUrl, requestOptions);
      return (await responsePromise.json()) || [];
    } catch (error) {
      console.log('Error:', error);
      return [];
    }
  };

  const apis = {

    async fetchCurrentUserInfo(url,bearerToken){
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${bearerToken}`,
      };
      let response = [];           
        try {
          response = await fetchDataApi(url,
            'GET',
            null,
            null,
            headers
          );
        } catch (error) {
          console.log('Error fetching User Info: ', error);
          return [];
        }
        return response;
    },

    async revokeAccessRequest(opIssuerUrl, accessToken){
      let response = {};
      const url =`${opIssuerUrl}/v1/revoke`;
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',        
      };
      const payload ={
        token_type_hint:'access_token',
        token:accessToken,
        client_id:oauth_dev.clientId
      };
     const payloadstr = querystring.stringify(payload);
      try {
        response = await fetchDataApi(url,
          'POST',
          null,
          payloadstr,
          headers
        );
      } catch (error) {
        console.log('Error fetching User Info: ', error);
        return {};
      }
      return response;
    }
  }

  export default apis;